import gql from 'graphql-tag';

export const ContractOnlineFormQuery = gql`
  query contractOnlineForm($formId: String!) {
    contractOnlineForm(formId: $formId) {
      id
      contract {
        id
        id_files
        id_poradce_2
        id_klient
        id_klient_2
        client2 {
          id
          prijmeni
          jmeno
          mobil
          email
          cislo_op
          rodne_cislo
          trvale_ulice
          trvale_cislo_popisne
          trvale_mesto
          trvale_psc
          koresp_cislo_popisne
          koresp_mesto
          koresp_psc
          koresp_ulice
          prijem
          prijem_vyse
        }
        id_tarif
        id_partner
        id_druh_tarifu
        id_provoz
        provozovna {
          id
          kod
          nazev
          ulice
          mesto
          psc
          ico
          dic
          zalozeno
          iban
          bic
          iban_smlouvy
        }
        cislo
        cisstavu
        status {
          id
          oznaceni
          nazev
          isstorno
          neutralni
          color
          starting
          blokace_provizi
          id_template_sms_smlouvy
          stav_dorazil_na_schuzku
          nasledujici_stavy
          konecny_stav
        }
        spravaDluhu {
          id
          id_smlouvy
          id_poradce
          id_preskore
          id_manager
          id_user_call_centra
          id_pravnik
          id_asistent_pravnika
          id_referent_rozplaceni
          id_supervizor
          id_referent_bankrotu
          id_posudkovy_pravnik
          typ
          varianta
          predpokl_vyse_zavazku
          celkova_vyse_zavazku
          pocet_veritelu
          prvni_platba_termin
          prvni_platba_zpusob
          pocatecni_splatka
          vyse_splatky

          misto
        }
        consultant2 {
          id
          cislo
          prijmeni
          jmeno
          mobil
          email
          file_avatar {
            id
            filename
          }
        }
        datum_podpisu
        datum
        datum_odeslani
        datum_vyst
        prijmeni
        jmeno
        titul
        rc
        datumnaroz
        pohlavy
        email
        mobil
        tel
        ulice
        cislo_popisne
        mesto
        psc
        koresp_ulice
        koresp_cislo_popisne
        koresp_mesto
        koresp_psc
        iban
        bic
        vytv_time
        edit_time
      }
      form_id
      status
      started
      data
      signMethod
      signIn
      signPhone
      signatureFile
      signatureFileId
      reportSignIn
      reportSignPhone
    }
  }
`;

export const UpdateCacheContractOnlineFormMutation = gql`
  mutation updateCacheContractOnlineForm($formId: ID!, $data: UpdateContractOnlineFormInput) {
    updateCacheContractOnlineForm(formId: $formId, data: $data) {
      id
    }
  }
`;

export const SaveStartedContractOnlineFormMutation = gql`
  mutation saveStartedContractOnlineForm($id: ID!) {
    saveStartedContractOnlineForm(id: $id) {
      id
    }
  }
`;

export const SaveContractOnlineFormDataMutation = gql`
  mutation saveContractOnlineFormData($id: ID!, $status: String, $data: UpdateContractOnlineFormInput) {
    saveContractOnlineFormData(id: $id, status: $status, data: $data) {
      id
      status
    }
  }
`;

export const CreateContractFromOnlineFormMutation = gql`
  mutation createContractFromOnlineForm($formId: ID!) {
    createContractFromOnlineForm(formId: $formId) {
      id
    }
  }
`;

export const SignContractOnlineFormMutation = gql`
  mutation signContractOnlineForm($id: ID!, $signatureId: Int!) {
    signContractOnlineForm(id: $id, signatureId: $signatureId) {
      id
    }
  }
`;

export const ReportSignContractOnlineFormMutation = gql`
  mutation reportSignContractOnlineForm($id: ID!, $signatureId: Int!) {
    reportSignContractOnlineForm(id: $id, signatureId: $signatureId) {
      id
    }
  }
`;

export const SendReportFilesToEmail = gql`
  mutation sendReportFilesToEmail($formId: String!) {
    sendReportFilesToEmail(formId: $formId) {
      success
    }
  }
`;
